var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 82,
    viewBox: "0 0 76 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:var(--primary-color, #9CD3FF)}.cls-2{fill:var(--accent-color, #203C63)}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.442h51.337a3 3 0 013 3V81a1 1 0 01-1.492.87L28.67 66.526 1.492 81.871A1 1 0 010 81V17.442a3 3 0 013-3z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 1a2 2 0 00-2 2v46.487l20.008-11.298a1 1 0 01.984 0L75 49.487V3a2 2 0 00-2-2H36zm0-1h37a3 3 0 013 3v46.487a1 1 0 01-1.492.87L54.5 39.06 34.492 50.357a1 1 0 01-1.492-.87V3a3 3 0 013-3z",
    className: "cls-2",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.480c5b5c93a677b5efa5cf15d92d719c.svg";
export { ForwardRef as ReactComponent };